export enum ContractorTypes {
    Carrier = "Carrier",
    Client = "Client",
    Other = "Other",
    Partner = "Partner",
    Payer = "Payer",
}
